import { Maybe } from 'maybeasy';
import { Error } from '../../../../ErrorHandling';
import {
  LearningDesignsResource,
  ProductLicenseResource,
} from '../../../LearningCollections/Types';

export interface Waiting {
  kind: 'waiting';
}

export interface Loading {
  kind: 'loading';
  page: number;
  timestamp: string;
  selectedProductLicenseResource: Maybe<ProductLicenseResource>;
}

export interface Ready {
  kind: 'ready';
  learningDesignsResource: LearningDesignsResource;
  selectedProductLicenseResource: Maybe<ProductLicenseResource>;
}

export type LearningDesignsState = Waiting | Loading | Ready | Error;

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (
  selectedProductLicenseResource: Maybe<ProductLicenseResource>,
  page: number = 1,
): Loading => ({
  kind: 'loading',
  timestamp: new Date().getTime().toString(),
  selectedProductLicenseResource,
  page,
});

export const ready = (
  learningDesignsResource: LearningDesignsResource,
  selectedProductLicenseResource: Maybe<ProductLicenseResource>,
): Ready => ({
  kind: 'ready',
  learningDesignsResource,
  selectedProductLicenseResource,
});
